import { defineStore } from "pinia";
import userApi from '@/api/user.js';
import { clone } from 'lodash';
import { loginModal } from '@/components/common/login'
import i18n from "@/i18n";
import eventEmitter from "@/utils/emitter.js"; // 新增引入

const { t: $t, locale } = i18n.global;

const defaultUserInfo = {
  avatar: '',
  name: '',
  mobile: '',
  bean: '0',
  coin: '0',
  diamond: '0',
}

const user = defineStore({
  id: 'user',
  state: () => ({
    count: 1,
    userInfo: clone(defaultUserInfo),
    isToken: false,
    navi: 0,
    sp: false,
    battleKey: '1',
    dailyKey1: '1',
    dailyRollKey: '1',
    activeItem: false,
    sandbox: false,
  }),
  actions: {
    getUserInfo() {
      return userApi.getPerInfo().then(res => {
        if (res.code != 200) {
          console.log('过期');
          return this.resetUserData()
        }
        this.userInfo = res.message

        // ===== 新增：检测邮箱是否为空，弹完善邮箱弹框 =====
        this.checkEmailBind()

        // 2026-09-24: 交易链接失效提醒（后端 /me 下发 steam_url_expired + 多语言文案）
        this.checkSteamUrl()

        return Promise.resolve(res.message)
      })
    },

    // 2026-09-24: 交易链接失效提醒（复用通用 notice 弹窗，每会话只提示一次）
    checkSteamUrl() {
      if (!this.userInfo || !this.userInfo.steam_url_expired) return
      if (sessionStorage.getItem('steamUrlExpiredDismissed')) return
      setTimeout(() => {
        eventEmitter.emit('api:steamUrlExpired', { desc: this.userInfo.steam_url_expired_msg || '' })
      }, 2000)
    },

    // 新增：检测邮箱绑定状态
    checkEmailBind() {
      // 没有邮箱 且 本次会话未关闭过该弹框
      if (!this.userInfo.email && !sessionStorage.getItem('emailRewardDismissed')) {
        // 延迟弹出，避免和登录弹框等冲突
        setTimeout(() => {
          eventEmitter.emit('api:showEmailReward')
        }, 1500)
      }
    },

    setToken(token = '') {
      console.log('setToken method:', token);
      if (token == '') {
        localStorage.removeItem('token')
        this.isToken = false
      } else {
        this.isToken = true
        localStorage.setItem('token', token)
        this.loginAfter()
      }
    },

    async updateUserData() {
      if (!this.isToken) {
        return this.resetUserData()
      }
      await this.getUserInfo()
      return this.userInfo
    },

    resetUserData() {
      this.setToken()
      this.userInfo = clone(defaultUserInfo)
    },

    async loginAfter() {
      await this.updateUserData()
    },

    async logout(force = false) {
      if (!force) {
        localStorage.removeItem('token')
        this.resetUserData()
      }
      return !this.isToken
    }
  },
  persist: {
    key: 'user-store',
    storage: window.localStorage,
  }
})

export default user